export default {
  header: {
    title: 'Ottimo! Ricevi gratuitamente i seguenti articoli con il tuo ordine:',
    subtitle: 'Applicheremo lo sconto durante il checkout.',
  },
  footer: {
    buttons: {
      no_thanks: 'No, grazie',
      add_to_basket: 'Aggiungi al carrello',
    },
  },
};
